export interface VoiceTtsOption { value: string; label: string; provider: 'openai' | 'azure'; }

export const VOICE_TTS_OPTIONS: VoiceTtsOption[] = [
  { value: 'alloy',                provider: 'openai', label: 'OpenAI · Alloy' },
  { value: 'ash',                  provider: 'openai', label: 'OpenAI · Ash' },
  { value: 'coral',                provider: 'openai', label: 'OpenAI · Coral' },
  { value: 'it-IT-ElsaNeural',     provider: 'azure',  label: 'Azure · Elsa (it-IT)' },
  { value: 'it-IT-DiegoNeural',    provider: 'azure',  label: 'Azure · Diego (it-IT)' },
];
